import { useMemo } from "react"
import { PagesPDFWrapper } from '../../../../../features/ui'
import { CustomerType } from "../../../state/types"

type Props = {
    id: string
    customerType: CustomerType
    items: any[]
    previewMode?: boolean
    renderPDFPage: (
        pageIndex: number,
        customerType: CustomerType,
        items: any[],
        pagesAmount: number
    ) => JSX.Element
}

export const PriceListPDFWrapper = (props: Props) => {
    const { id, customerType, items, previewMode, renderPDFPage } = props

    const pagesItems = useMemo(() => {
        const sortedItems = [...items]

        const pages: any[][] = []
        
        const pushPages = (startIndex = 0) => {
            const isFirstPage = startIndex === 0
            const remainingItems = sortedItems.slice(startIndex)
            
            if (remainingItems.length > 0) {
                const pageSize = isFirstPage ? 16 : 18        
                pages.push(remainingItems.slice(0, pageSize))
                pushPages(startIndex + pageSize)
            }
        }
        pushPages()
        return pages
    }, [items])

    const renderPages = pagesItems.map((pageItems, index) => 
        (pageIndex: number) => renderPDFPage(pageIndex, customerType, pageItems, pagesItems.length)
    )

    return (
        <PagesPDFWrapper
            id={id}
            dataType={customerType as any}
            previewMode={previewMode}
            renderPages={renderPages as any}
        />
    )
}